const RedeemActionTypes = {
    TOGGLE_REDEEM_HIDDEN: 'TOGGLE_REDEEM_HIDDEN',
    ADD_REDEEM_ITEM: 'ADD_REDEEM_ITEM',
    CLEAR_REDEEM_ITEM_FROM_REDEEM: 'CLEAR_REDEEM_ITEM_FROM_REDEEM',
    REMOVE_REDEEM_ITEM:'REMOVE_REDEEM_ITEM',
    SET_REDEEM_ITEM:'SET_REDEEM_ITEM',
    CHANGE_REDEEM_ITEM_QUANTITY: 'CHANGE_REDEEM_ITEM_QUANTITY'
}

export default RedeemActionTypes